import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import loginApi from "../../../apis/login";
import messages from "../../../constants/messages";
import { LoginFormStatus } from "../../../enums";

interface LoginState {
  status: LoginFormStatus | null;
  resendMagicLinkStatus: LoginFormStatus | null;
  errorMessage: string;
  parentConfirmed: boolean;
}

const initialState: LoginState = {
  status: null,
  resendMagicLinkStatus: null,
  errorMessage: "",
  parentConfirmed: false,
};

const login = createAsyncThunk(
  "login/doLogin",
  async (email: string, { rejectWithValue }) => {
    try {
      const response = await loginApi.doLogin(email);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const resendMagicLink = createAsyncThunk(
  "magicLink/resend",
  async (email: string, { rejectWithValue }) => {
    try {
      const response = await loginApi.doLogin(email);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = LoginFormStatus.LOADING;
        state.errorMessage = "";
      })
      .addCase(login.fulfilled, (state) => {
        state.status = LoginFormStatus.SUCCESS;
        state.errorMessage = "";
      })
      .addCase(login.rejected, (state, action) => {
        const { statusCode, errors } =
          (action.payload as {
            statusCode?: number;
            errors?: { message: string }[];
          }) || {};
        const errorMessage =
          statusCode === 500 || statusCode === undefined
            ? messages.EMAIL_NOT_FOUND
            : (errors && errors[0].message) || messages.EMAIL_NOT_FOUND;
        state.status = LoginFormStatus.FAILED;
        state.errorMessage = errorMessage;
      })
      .addCase(resendMagicLink.pending, (state) => {
        state.resendMagicLinkStatus = LoginFormStatus.LOADING;
        state.errorMessage = "";
      })
      .addCase(resendMagicLink.fulfilled, (state) => {
        state.resendMagicLinkStatus = LoginFormStatus.SUCCESS;
        state.errorMessage = "";
      })
      .addCase(resendMagicLink.rejected, (state, action) => {
        const payload = action.payload as
          | { statusCode?: number; errors?: { message: string }[] }
          | undefined;
        const { statusCode, errors } = payload || {};
        const errorMessage =
          statusCode === 500 || statusCode === undefined
            ? messages.EMAIL_NOT_FOUND
            : (errors && errors[0].message) || messages.EMAIL_NOT_FOUND;
        state.resendMagicLinkStatus = LoginFormStatus.FAILED;
        state.errorMessage = errorMessage;
      });
  },
});

export { login, resendMagicLink };
export default loginSlice;
